import BackgroundBlobs from '@/components/BackgroundBlobs';
import LoadingCard from '@/components/LoadingCard';
import { classes } from './utils';

export default function LoadingApp() {
  return (
    <div className={classes.wrapper}>
      <BackgroundBlobs />
      <LoadingCard message="Loading" />
    </div>
  );
}
